import { z } from 'zod'

import { optional, required } from './schemaHelpers'

export const buildCarServiceSchema = () =>
  z.object({
    pickupPlace: required(),
    pickupDate: required(),
    pickupHour: required(),
    dropoffPlace: required(),
    dropoffDate: required(),
    dropoffHour: required(),
    carCategory: required(),
    carType: required(),
    carTransmission: required(),
    noteAggiuntive: optional()
  })
